import React from "react";

const CallInProgress = () => {
  return (
    <React.Fragment>
      <p>You will receive a call and then be connected to the other party</p>
    </React.Fragment>
  );
};

export default CallInProgress;
